export enum Tranasitions {
  default = '0.1s ease-out',
}

const createTransition = (
  properties: string[],
  ...transProps: [string?]
): any => {
  const transition = transProps.length
    ? transProps.join(' ')
    : Tranasitions.default;

  return `${properties.join(` ${transition},`)} ${transition};`;
};

export const transition = (...args: any[]) =>
  `transition: ${createTransition(...(args as [any]))};`;

// css`${propsToAnimate} ${transition}
export default createTransition;
